import { TOGGLE_SIDEBAR, SHOW_MESSAGE_BAR, DISMISS_MESSAGE_BAR } from "../actions/app";

const initialState = {
  sidebarOpen: true,
  message: null,
  messageUUID: null,
  messageType: null,
};

function app(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return Object.assign({}, state, {
        sidebarOpen: !state.sidebarOpen,
      });
    case SHOW_MESSAGE_BAR:
      return Object.assign({}, state, {
        message: action.message,
        messageUUID: action.messageUUID,
        messageType: action.messageType,
      });
    case DISMISS_MESSAGE_BAR:
      if (state.messageUUID !== action.messageUUID) {
        return state;
      }
      return Object.assign({}, state, {
        messageUUID: null,
      });
    default:
      return state;
  }
}

export default app;
